export default __webpack_public_path__ + "static/media/ic-overview-db.d51eca31.svg";